import type { FC } from "react";
import type { DialogController } from "../../../../utils/hooks/use-dialog";
import type { SegmentCrudDialogState } from "./hooks/use-segment-crud-datagrid-dialog";

import { LinearProgress } from "@mui/material";
import { useFlags } from "../../../../server/optimizely";
import { SegmentCrudDataGridDialogV1 } from "./segment-crud-data-grid-dialog-v1";
import { SegmentCrudDataGridDialogV2 } from "./segment-crud-data-grid-dialog-v2";
import type { SegmentRowWithOptions } from "./types";

export const SegmentCrudDataGridDialog: FC<{
  dialog: DialogController<SegmentCrudDialogState>;
  is_recipient_type: boolean;
  reload: () => void;
  processedSegments: SegmentRowWithOptions[];
}> = ({ dialog, ...props }) => {
  const {
    flags: { select_multiple_segments },
    flagsLoaded,
  } = useFlags("select_multiple_segments");

  if (!dialog.data || !dialog.open) return null;

  if (!flagsLoaded) return <LinearProgress />;

  return select_multiple_segments ? (
    <SegmentCrudDataGridDialogV2 {...props} dialog={dialog} />
  ) : (
    <SegmentCrudDataGridDialogV1 {...props} dialog={dialog} />
  );
};
